import { render, staticRenderFns } from "./EditEmployment.vue?vue&type=template&id=80a27c48&scoped=true"
import script from "./EditEmployment.vue?vue&type=script&lang=js"
export * from "./EditEmployment.vue?vue&type=script&lang=js"
import style0 from "./EditEmployment.vue?vue&type=style&index=0&id=80a27c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a27c48",
  null
  
)

export default component.exports